<template>
  <div class="component_card">
    <div class="column ">
      <h1 class="text_lg p0 tal_c">
        <strong>{{$t('msg.enable_2fa')}}</strong>
      </h1>
    </div>
    <div class="column columns redeem_form mw100">
      <div class="column">
        <div class="column">
          <div class="column">
            <div class="column tal_c">
              <p>{{$t('msg.twofa_info')}}</p>
            </div>
          </div>
          <div class="column tal_c">
            <div class="qrcode" v-if="qrcode">
              <img :src="qrcode.href" alt>
            </div>
          </div>
          <div class="column">
            <p class="tal_c">
              {{otpCode}}
              <i
                class="icon_class_1"
                type="button"
                v-clipboard:copy="otpCode"
                :options="{ width: 200 }"
                v-clipboard:success="onCopySuccess"
                v-clipboard:error="onCopyError"
                v-html="iconSets.copy"
              >{{$t('msg.copy')}}</i>
            </p>
          </div>
          <div class="column ">
            <p v-html="$t('msg.copy_twofa')"></p>
          </div>
          <div class="column">
            <p>{{$t("msg.past_2fa")}}:</p>
            <input class="amount_address" type="text" v-model="twoFA" style="width:100%;">
          </div>
          <div class="column">
            <button
              class="btn_redeem"
              style="width:100%;"
              @click="postOptConfirm(twoFA)"
            >{{$t("msg.activate")}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  created() {
    this.getOtpCode();
    this.getOtpImage();
  },
  mounted() {},
  data: () => ({
    otpCode: "",
    twoFA: "",
    qrcode: ""
  }),
  components: {},
  methods: {
    async getOtpCode() {
      let resp = await this.$store.dispatch("getOtpCode");
      this.otpCode = resp.data;
    },

    async getOtpImage() {
      try {
        let resp = await this.$store.dispatch("getOtpImage");
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement("img");
        link.href = url;
        this.qrcode = link;
      } catch (e) {
        this.logError(e);
      }
    },

    async postOptConfirm(twoFA) {
      try {
        let resp = await this.$store.dispatch("postOptConfirm", twoFA);
        this.notifySuccess(this.$t("msg.activation_successful_2fa"), 5000);
        this.$emit("getOptStatus");
      } catch (e) {
        this.notifyDanger(this.$t("msg.invalid_2fa_code"), 5000);
        this.getOtpCode();
        this.getOtpImage();
      }
    }
  },
  computed: {
    ...mapGetters([])
  },
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/private/services/redeem_steps/Redeem2fa.vue